import { Controller } from '@hotwired/stimulus';
import Axios from "../axios";

export default class extends Controller {

    connect() {

        const context = this;
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.element.querySelectorAll('a.link').forEach(function(link) {
            link.addEventListener('click', async (e) => {

                const id = link.dataset.id;
                const url = `/wp-json/api/visits?rest_language=${context.currentLanguageCode}`;

                try {
                    await Axios.post(url, { 'id': id }, { headers: {'Content-Type': 'application/json;charset=UTF-8'} });
                } catch (error) {}
            });
        });
    }
}
